


uniform float uTime;
uniform float uOffset;
 
varying vec2 vUv;
varying vec2 vPos;


float mod289(float x){return x - floor(x * (1.0 / 289.0)) * 289.0;}
vec4 mod289(vec4 x){return x - floor(x * (1.0 / 289.0)) * 289.0;}
vec4 perm(vec4 x){return mod289(((x * 34.0) + 1.0) * x);}

float noise(vec3 p){
    vec3 a = floor(p);
    vec3 d = p - a;
    d = d * d * (3.0 - 2.0 * d);

    vec4 b = a.xxyy + vec4(0.0, 1.0, 0.0, 1.0);
    vec4 k1 = perm(b.xyxy);
    vec4 k2 = perm(k1.xyxy + b.zzww);

    vec4 c = k2 + a.zzzz;
    vec4 k3 = perm(c);
    vec4 k4 = perm(c + 1.0);

    vec4 o1 = fract(k3 * (1.0 / 41.0));
    vec4 o2 = fract(k4 * (1.0 / 41.0));

    vec4 o3 = o2 * d.z + o1 * (1.0 - d.z);
    vec2 o4 = o3.yw * d.x + o3.xz * (1.0 - d.x);

    return o4.y * d.y + o4.x * (1.0 - d.y);
}

  vec2 rotate2D(vec2 value, float angle)
{
    float s = sin(angle);
    float c = cos(angle);
    mat2 m = mat2(c, s, -s, c);
    return m * value;
}

  void main() {


    vec3 transformed = position;

    vec4 mvPosition = vec4( transformed, 1.0 );

    #ifdef USE_INSTANCING

      mvPosition = instanceMatrix * mvPosition; 

    #endif
    // vec3 newPosition = transformed.xyz;
    //     // Wind
    // float windOffset = noise(vec3(
    //     sin(uTime * uOffset) - 0.5,
    //     sin(uTime * uOffset) - 0.5,
    //     1.0
    // ));
    // windOffset *= pow(uv.y, 2.0) * 0.4;
    // mvPosition.x += windOffset * 0.6;
    


    mvPosition = modelViewMatrix * mvPosition;



    gl_Position = projectionMatrix * mvPosition;
    vUv = uv;
    vPos = transformed.xy;

  }